import React, {createContext, useContext, useEffect, useMemo, useRef} from 'react';
import {track, tourParameters} from './bookingAnalytics';

const Context = createContext(() => {});
export const useTourTracking = () => useContext(Context);

export default function TourTracking({tour, children}) {
    const viewed = useRef(null);
    const parameters = useMemo(() => tourParameters(tour), [tour]);
    useEffect(() => {
        if (viewed.current !== parameters.tour_id) {
            track('view_item', parameters, { currency: 'AUD', items: [{item_id: parameters.tour_id, item_name: parameters.tour_name}] });
            viewed.current = parameters.tour_id;
        }
    }, [parameters]);
    useEffect(() => {
        const click = event => {
            const anchor = event.target.closest?.('a[href]');
            if (event.target.closest?.('[data-line-consult]') || (anchor && /^https?:\/\/(line\.me|lin\.ee)\//i.test(anchor.href))) track('line_consult_click', parameters);
        };
        document.addEventListener('click', click);
        return () => document.removeEventListener('click', click);
    }, [parameters]);
    return <Context.Provider value={(event, extra) => track(event, {...parameters, ...extra})}>{children}</Context.Provider>;
}
